<template>
  <div class="dashboard_warp">
    <div class="dashboard_map_box">
      <!--    3D地图-->
      <div class="dashboard_map_card" v-if="isShowMap">
        <div class="map_card_title">
          <img src="@/assets/dashboard/icon_tj.png" />
          <div class="title_warp">代理人地图</div>
        </div>
        <div class="map_card_input">
          <!-- 只有燕姐-推荐人模式--首页需要下拉选择下级代理人 -->
          <el-select
            v-if="isShowMap && this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN_MAP && !agentDetail?.agentUserId"
            v-model="selectedAgentId" placeholder="请选择下级代理人" @change="onSelectAgent" class="map_card_select">
            <el-option v-for="item in agentConfigList" :key="item.agentUserId" :label="item.agentDesc"
              :value="item.agentUserId" />
          </el-select>

          <el-input v-model="currentAddress" readonly placeholder="请选择行政区划名称" clearable style="margin-right: 12px;"
            @focus="onShowRegionPicker" class="map_card_input_region">
            <i slot="prefix" class="el-input__icon el-icon-map-location"></i>
          </el-input>
          <el-button type="primary" @click="onClearAddress" class="map_card_clear">重置</el-button>
        </div>

        <region-3-d-map v-if="showMap" :adcode="mapAdcode" width="100%" height="460px" />

        <div class="map_card_item_body">
          <div class="map_card_item" v-if="agentData?.agentName">
            <div class="map_card_item_title"><img src="@/assets/normal/agentName.png" alt=""> {{ agentData.agentName }}：
            </div>
            <div class="map_card_item_value">{{ agentData.agentRealName }}</div>
          </div>

          <div class="map_card_item" v-if="agentData?.achievement">
            <div class="map_card_item_title"><img src="@/assets/normal/achievement.png" alt=""> 业绩：</div>
            <div class="map_card_item_value">{{ agentData?.achievement || 0 }}</div>
          </div>

          <div class="map_card_item" v-if="agentData?.subAgentName">
            <div class="map_card_item_title"><img src="@/assets/normal/subAgentName.png" alt="">{{
              agentData?.subAgentName
            }}：</div>
            <div class="map_card_item_value">{{ agentData?.subAgentCount || 0 }}</div>
          </div>

          <div class="map_card_item">
            <div class="map_card_item_title"><img src="@/assets/normal/totalUsers.png" alt="">有效订单用户数量：</div>
            <div class="map_card_item_value">{{ agentData?.totalUsers || 0 }}</div>
          </div>

        </div>
      </div>

      <div :class="['dashboard_statistics_picture', { 'isShowMap': isShowMap }]">
        <!--      会员统计-->
        <div class="dashboard_statistics_picture_item">
          <div class="statistics_picture_item_left">
            <div class="statistics_picture_item_title">
              <img src="@/assets/dashboard/icon_tj.png" />
              <div class="title_warp">下级人数统计</div>
            </div>
            <div>
              <div ref="myMemberChart" style="width: 100%;height:260px;"></div>
            </div>
          </div>
          <div class="statistics_picture_item_right">
            <div>
              <div class="statistics_picture_item_right_title">
                {{ !showMap ? "下级总人数" : "下级有效人数" }}
              </div>
              <div class="statistics_picture_item_right_value">
                {{ memberData.totalCount }}
              </div>
            </div>
            <div style="margin-top: 20px">
              <div class="statistics_picture_item_right_title">今日新增(人)</div>
              <div class="statistics_picture_item_right_value">
                {{ memberData.addCount }}
              </div>
            </div>
          </div>
        </div>
        <!--      订单统计-->
        <div class="dashboard_statistics_picture_item">
          <div class="statistics_picture_item_left">
            <div class="statistics_picture_item_title">
              <img src="@/assets/dashboard/icon_tj.png" />
              <div class="title_warp">订单统计</div>
            </div>
            <div>
              <div ref="myOrderChart" style="width: 100%;height:260px;"></div>
            </div>
          </div>
          <div class="statistics_picture_item_right">
            <div>
              <div class="statistics_picture_item_right_title">今日订单</div>
              <div class="statistics_picture_item_right_value">
                {{ round(orderData.totalCount) }}
              </div>
            </div>
            <div style="margin-top: 20px">
              <div class="statistics_picture_item_right_title">
                今日订单金额(元)
              </div>
              <div class="statistics_picture_item_right_value">
                {{ round(orderData.totalAmount) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 业绩 -->
    <!-- <div class="dashboard_performance_card" v-if="!isShowMap">
      <div class="performance_card_body">
        <div class="performance_item">
          <div class="performance_title">代理等级</div>
          <div class="performance_value">
            {{ levelName || "-" }}
          </div>
        </div>
        <div class="performance_item">
          <div class="performance_title">大区累计业绩</div>
          <div class="performance_value">
            {{ departmentData?.maxDepartmentValue || "-" }}
          </div>
        </div>
        <div class="performance_item">
          <div class="performance_title">小区累计业绩</div>
          <div class="performance_value">
            {{ departmentData?.minDepartmentValue || "-" }}
          </div>
        </div>
      </div>
    </div> -->

    <!--底部卡片统计-->
    <div style="margin-top: 20px">
      <dashboard-card :balanceData="balanceData" :isAgentLogin="isAgentLogin" @onWithdraw="onWithdraw" />
    </div>

    <drawDialog :dialog-visible="dialogFormVisible" :balance="balance" @save="handleSave" @close="handleDialogClose"
      :disabled="disabled" />
    <RegionPicker :show="showRegionPicker" :agentUserId="agentUserId" @confirm="handleRegionConfirm"
      @close="showRegionPicker = false" />
  </div>
</template>

<script>
import defaultSettings from "@/settings";
import echarts from "echarts";
import {
  getUsersStatis,
  getOrderStatis,
  getBalanceStatis,
  getTbcRewardPool,
  getTbcWithdraw,
  getDepartmentalPerformance,
  getAgentPerformance,
  getAgentDetailList
} from "@/api/dashboard";
import drawDialog from "@/views/account-profit/components/withdraw-dialog.vue";
import { getLogionUserInfo } from "@/utils/auth"; // 验权
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
import { isPositiveNegativeOrZero } from "@/utils/index";
import dashboardCard from "@/components/dashboardCard/index.vue";
import Region3DMap from "@/components/Region3DMap/index.vue";
import RegionPicker from "@/components/regionPicker/index.vue";

export default {
  name: "Dashboard",
  props: {
    agentDetail: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dashboardBg: defaultSettings.dashboardBj,
      dashboardIcon: defaultSettings.dashboardIcon,
      memberData: {
        addCount: 0,
        totalCount: 0
      },
      orderData: {
        totalAmount: 0,
        totalCount: 0
      },
      levelName: "",
      balance: 0,
      dialogFormVisible: false,
      balanceData: [],
      isAgentLogin: null,
      cardData: {},
      departmentData: null,
      agentUserId: "",
      // 3D地图相关
      mapAdcode: getLogionUserInfo()?.adcode,
      showMap: true,
      showRegionPicker: false,
      currentAddress: getLogionUserInfo()?.regionAddress,
      agentData: {},
      currentRegionId: getLogionUserInfo()?.regionId,
      myMemberChart: null,
      myOrderChart: null,
      isShowMap: false,
      initAdcode: getLogionUserInfo()?.adcode,
      initAddress: getLogionUserInfo()?.regionAddress,
      agentConfigList: [], // 选择的下级代理列表
      selectedAgentId: null, // 选择的下级代理人
    };
  },
  created() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.isShowMap = getLogionUserInfo()?.teamLogo == 0; // 0 黄丽账号， 1.显示3D地图
    this.agentUserId =
      (this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT && this.disabled) ||
        this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        ? this.agentDetail?.agentUserId
        : getLogionUserInfo()?.agentUserId;

    // 燕姐
    if (this.isShowMap && this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN_MAP) {
      this.currentAddress = this.agentDetail?.regionAddress || getLogionUserInfo()?.regionAddress;
      this.initAddress = this.agentDetail?.regionAddress || getLogionUserInfo()?.regionAddress;
      this.mapAdcode = this.agentDetail?.adcode || getLogionUserInfo()?.adcode;
      this.initAdcode = this.agentDetail?.adcode || getLogionUserInfo()?.adcode;
      this.agentUserId = getLogionUserInfo()?.ID;
      if (this.agentDetail?.agentUserId) {
        this.agentUserId = this.agentDetail?.agentUserId
      }
      this.getAgentDetailListData();
      this.onClearAddress();
    }
    console.log('当前地址----:', this.isShowMap, this.isAgentLogin, '---', this.agentDetail, this.agentUserId, this.currentAddress, getLogionUserInfo())
  },
  mounted() {
    this.initMemberChart();
    this.initOrderChart();
    this.getTbcWithdrawData();
    // 非黄丽账号，显示3D地图
    if (this.isShowMap) {
      console.log('3D地图显示', this.isShowMap)
      this.onAgentPerformanceData();
      // this.handleMapSearch()
    }
    // this.getDepartmentalPerformanceData();
    this.levelName = getLogionUserInfo()?.agentName;
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.myMemberChart) {
      this.myMemberChart.dispose();
    }
    if (this.myOrderChart) {
      this.myOrderChart.dispose();
    }
  },
  methods: {
    isPositiveNegativeOrZero,
    /**
     * 获取下级代理人列表
     */
    getAgentDetailListData() {
      console.log('下级代理人列表-1:', this.agentUserId)
      getAgentDetailList({
        page: 1,
        pageSize: 1000
      }).then(
        resp => {
          console.log('下级代理人列表:', resp.data)
          if (resp && resp.bizcode === 100) {
            this.agentConfigList = resp.data?.entitys || [];
          }
        }
      );
    },
    // 选择下级代理人
    onSelectAgent(item) {
      console.log('选择的下级代理人:', item, this.agentConfigList)
      const val = this.agentConfigList.find((el) => el.agentUserId == item)
      console.log('选择的下级代理人-1:', val)
      this.selectedAgentId = item

      this.showMap = false
      this.$nextTick(() => {
        this.mapAdcode = val?.adcode || ''
        this.showMap = true
        this.agentUserId = val?.agentUserId || ''
        this.currentAddress = val?.regionAddress || ''

        this.initMemberChart();
        this.initOrderChart();
        this.getTbcWithdrawData();

        this.onAgentPerformanceData({
          regionId: val?.regionId,
        })
      })

    },
    handleRegionConfirm(item) {
      console.log('选择的行政区划代码:', item)
      this.currentRegionId = item.regionId;
      this.currentAddress = this.currentAddress + item.path.join('')
      this.handleMapSearch(item)
    },
    /**
     * 3D地图搜索
     */
    handleMapSearch(val) {
      const item = val?.parentAdcode;
      const code = item && String(item).trim() || getLogionUserInfo()?.adcode;
      if (!code) {
        this.$message.warning('请输入行政区划代码')
        return
      }
      if (!/^\d{6}$/.test(item)) {
        this.$message.warning('行政区划代码为6位数字，如：440300')
        return
      }
      this.showMap = false
      this.$nextTick(() => {
        this.mapAdcode = item
        this.showMap = true
        this.onAgentPerformanceData(val)
      })
    },
    // 查询代理业绩数据
    onAgentPerformanceData(val) {
      console.log('查询代理业绩数据----', val, this.agentUserId)
      const params = {
        agentUserId: this.agentUserId
      }
      if (val?.regionId && val?.regionId != getLogionUserInfo()?.regionId) {
        params.regionId = val?.regionId;
      }
      getAgentPerformance(params).then(
        resp => {
          if (resp && resp.bizcode === 100) {
            this.agentData = resp.data;
            console.log('代理业绩数据:', resp.data)
          }
        }
      );
    },

    // 查询大区累计业绩
    getDepartmentalPerformanceData() {
      getDepartmentalPerformance({ agentUserId: this.agentUserId }).then(
        resp => {
          if (resp && resp.bizcode === 100) {
            this.departmentData = resp.data;
          }
        }
      );
    },
    /**
     * 窗口resize处理
     */
    handleResize() {
      if (this.myMemberChart) {
        this.myMemberChart.resize();
      }
      if (this.myOrderChart) {
        this.myOrderChart.resize();
      }
    },
    /**
     * 会员图表
     */
    initMemberChart() {
      this.$nextTick(() => {
        if (this.myMemberChart) {
          this.myMemberChart.dispose();
        }
        this.myMemberChart = echarts.init(this.$refs.myMemberChart);
        getUsersStatis({ agentUserId: this.agentUserId }).then(resp => {
          const chartOptions = {
            title: {},
            grid: {
              left: "3%",
              right: "4%",
              bottom: "15%", // 增加底部边距从3%到15%
              containLabel: true
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                rotate: 45, // 旋转45度防止标签重叠
                interval: 0, // 显示所有标签
                fontSize: 12, // 适当字体大小
                margin: 15 // 增加标签与轴线的距离
              }
            },
            yAxis: {
              type: "value"
            },
            series: [
              {
                data: [],
                type: "line",
                smooth: true
              }
            ]
          };
          if (resp && resp.bizcode === 100) {
            this.memberData.addCount = resp.data.totalTodayNumber;
            this.memberData.totalCount = resp.data.totalNumber;
            const arrayData = resp.data.relationDtoList.reverse();
            chartOptions.xAxis.data = arrayData.map(item => item.register_date);
            chartOptions.series[0].data = arrayData.map(item => item.daily_count);
          } else {
            chartOptions.xAxis.data = [];
            chartOptions.series[0].data = [];
          }
          this.myMemberChart.setOption(chartOptions); // 使用响应式数据初始化图表
          this.$nextTick(() => {
            this.myMemberChart.resize();
          });
        });
      });
    },
    onShowRegionPicker() {
      this.currentAddress = this.initAddress;
      this.mapAdcode = this.initAdcode;
      this.showRegionPicker = true;
      this.showMap = false
      this.onAgentPerformanceData()
      this.$nextTick(() => {
        this.showMap = true
      })
    },
    onClearAddress() {
      this.currentAddress = this.initAddress;
      this.mapAdcode = this.initAdcode;
      this.showRegionPicker = false;
      this.showMap = false
      this.$nextTick(() => {
        this.onAgentPerformanceData()
        this.showMap = true
      })
    },
    onWithdraw(item) {
      console.log("item--1", item);
      this.dialogFormVisible = true;
    },
    handleSave() {
      this.onBalanceStatis();
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      this.dialogFormVisible = false;
    },
    // 查询btc账户
    getTbcWithdrawData() {
      getTbcWithdraw({}).then(resp => {
        if (resp && resp.bizcode === 100) {
          // this.balance = resp.data.tbc;
          this.cardData = resp.data;
          this.onBalanceStatis();
        }
      });
    },
    /**
     * 订单图表
     */
    initOrderChart() {
      this.$nextTick(() => {
        if (this.myOrderChart) {
          this.myOrderChart.dispose();
        }
        this.myOrderChart = echarts.init(this.$refs.myOrderChart);
        getOrderStatis({ agentUserId: this.agentUserId }).then(resp => {
          const chartOptions = {
            title: {},
            tooltip: {
              trigger: "axis"
            },
            legend: {
              data: ["订单金额", "订单数量"]
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "15%", // 增加底部边距从3%到15%
              containLabel: true
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                rotate: 45, // 旋转45度防止标签重叠
                interval: 0, // 显示所有标签
                fontSize: 12, // 适当字体大小
                margin: 15 // 增加标签与轴线的距离
              }
            },
            yAxis: {
              type: "value"
            },
            series: [
              {
                name: "订单金额",
                type: "line",
                stack: "Total",
                data: []
              },
              {
                name: "订单数量",
                type: "line",
                stack: "Total",
                data: []
              }
            ]
          };
          if (resp && resp.bizcode === 100) {
            this.orderData.totalAmount = resp.data.totalTodayAmount;
            this.orderData.totalCount = resp.data.totalTodayOrders;
            const arrayData = resp.data.agentOrderStatisticsDtoList.reverse();
            chartOptions.xAxis.data = arrayData.map(item => item.orderDate);
            chartOptions.series[0].data = arrayData.map(
              item => item.dailyOrderAmount
            ); //金额
            chartOptions.series[1].data = arrayData.map(
              item => item.dailyOrderCount
            ); //数量
          } else {
            chartOptions.xAxis.data = [];
            chartOptions.series[0].data = [];
            chartOptions.series[1].data = [];
          }
          this.myOrderChart.setOption(chartOptions); // 使用响应式数据初始化图表
          this.$nextTick(() => {
            this.myOrderChart.resize();
          });
        });
      });
    },
    // updateChart() {
    //   // 更新图表数据的方法
    //   this.chartOptions.series[0].data = [12, 32, 21, 23]; // 更新数据数组
    //   this.initChart(); // 重新初始化图表以应用更新（实际应用中应使用myChart.setOption更新）
    // }
    getTbcRewardPoolData() {
      getTbcRewardPool({}).then(({ data, bizcode }) => {
        if (bizcode === 100) {
          if (!this.isShowMap) {
            this.balanceData.push(
              {
                name: "奖励池",
                iconUrl: require("@/assets/dashboard/icon_xjhb.png"),
                todayAmount: data.todayTbc,
                cumulativeAmount: data.totalTbc,
                balance: data.balanceTbc,
                color: "#fdf1dd",
                leftTitle: "今日",
                rightTitle: "累计",
                balanceTitle: "余额"
              },
              {
                name: "发展基金",
                iconUrl: require("@/assets/dashboard/icon_xjhb.png"),
                todayAmount: data.developTodayTbc,
                cumulativeAmount: data.developTotalTbc,
                balance: data.developBalanceTbc,
                color: "#ebfaf2",
                leftTitle: "今日",
                rightTitle: "累计",
                balanceTitle: "余额"
              }
            );
          }

        }
      });
    },
    /**
     * 查询余额的数据
     */
    onBalanceStatis() {
      getBalanceStatis({ agentUserId: this.agentUserId }).then(
        ({ data, bizcode }) => {
          if (bizcode === 100) {
            this.balanceData = [
              {
                name: "销售额",
                iconUrl: require("@/assets/dashboard/icon_cjcs.png"),
                todayAmount: data.todaySuccessAmount,
                cumulativeAmount: data.totalSuccessAmount,
                color: "#F1F7FF",
                leftTitle: "今日",
                rightTitle: "累计"
              },
              {
                name: "分润",
                iconUrl: require("@/assets/dashboard/icon_xjhb.png"),
                todayAmount: data.todayProfit,
                cumulativeAmount: data.totalProfit,
                color: "#FFF5EA",
                leftTitle: "今日",
                rightTitle: "累计"
              },
              {
                name: "账户余额",
                iconUrl: require("@/assets/dashboard/icon_xjyj.png"),
                todayAmount: data.balance,
                cumulativeAmount: data.freezeBalance,
                color: "#FAF3FF",
                leftTitle: "可用余额 ",
                rightTitle: "总余额",
                btn: "提现"
              },
              {
                name: "数字积分奖励",
                iconUrl: require("@/assets/dashboard/icon_cjcs.png"),
                todayAmount: this.cardData.todayTbc,
                cumulativeAmount: this.cardData.totalTbc,
                color: "#F1F7FF",
                leftTitle: "今日",
                rightTitle: "累计"
              }
            ];
            this.balance = data.balance || 0;
            // 奖励池和发展基金仅指定特殊账号可见（分公司代理，大区代理，省代理）
            if (
              this.levelName == "分公司代理" ||
              this.levelName == "大区代理" ||
              this.levelName == "省代理"
            ) {
              // this.getTbcRewardPoolData();
            }
            // 如果this.isAgentLogin = 2则不展示分润和账户余额
            if (this.isAgentLogin == 2) {
              this.balanceData = this.balanceData.filter(
                item => item.name !== "分润" && item.name !== "账户余额"
              );
            }
          }
        }
      );
    },
    round(val) {
      return Math.round(Number(val) * 100) / 100;
    }
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    }
  },
  components: {
    dashboardCard,
    drawDialog,
    Region3DMap,
    RegionPicker
  }
};
</script>

<style lang="scss" scoped>
.dashboard_warp {
  background: #f7f7f7;
  // height: calc(100vh - 144px);
  padding: 30px;
  overflow-y: auto;
  overflow-x: hidden; // 禁止横向滚动
  box-sizing: border-box; // 确保padding计算在宽度内
  width: 100%; // 确保占满可用宽度

  .dashboard_statistics_picture {
    display: flex;
    justify-content: space-between;
    flex: 1;
    margin-left: 20px;
    gap: 15px;
    box-sizing: border-box; // 确保padding计算在宽度内

    &.isShowMap {
      flex-direction: column;
    }
  }

  .dashboard_statistics_picture_item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 1px 6px 0px rgba(204, 204, 204, 0.3);
    border-radius: 10px;
    padding: 30px;
    box-sizing: border-box; // 确保padding计算在宽度内

    .statistics_picture_item_title {
      display: flex;
      align-items: center;
      flex-shrink: 0; // 防止标题被压缩
      word-break: break-word; // 确保长文本可以换行

      .title_warp {
        font-size: 24px;
        color: #333333;
        margin-left: 10px;
      }
    }

    .statistics_picture_item_left {
      width: 70%;
      min-width: 0; // 允许内容收缩
      box-sizing: border-box; // 确保padding计算在宽度内
      padding: 10px;

      >div {
        width: 100%;
      }
    }

    .statistics_picture_item_right {
      width: 30%;
      display: grid;
      margin-left: 20px;
      flex-shrink: 0; // 防止右侧被压缩
      box-sizing: border-box; // 确保padding计算在宽度内

      .statistics_picture_item_right_title {
        font-size: 18px;
        color: #000000;
        word-break: break-word; // 确保长文本可以换行
      }

      .statistics_picture_item_right_value {
        background: #f2f4f8;
        border-radius: 5px;
        font-family: DINPro;
        font-weight: bold;
        font-size: 40px;
        color: #111111;
        padding: 10px 0;
        margin-top: 20px;
        text-align: center; // 改为居中显示
        word-break: break-all; // 确保数字可以换行
        box-sizing: border-box; // 确保padding计算在宽度内
      }
    }
  }
}

// 业绩模块样式
.dashboard_performance_card {
  background: #ffffff;
  box-shadow: 0px 1px 6px 0px rgba(204, 204, 204, 0.3);
  border-radius: 10px;
  padding: 30px;
  margin-top: 20px;
  box-sizing: border-box;
  width: 100%;

  .performance_card_header {
    margin-bottom: 20px;

    .performance_level {
      display: flex;
      align-items: center;

      .level_button {
        background: #409eff;
        color: white;
        padding: 6px 16px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        margin-right: 12px;
      }

      .current_level {
        font-size: 14px;
        color: #666;
      }
    }
  }

  .performance_card_body {
    display: flex;
    justify-content: space-around;
    padding-top: 20px;

    .performance_item {
      text-align: center;
      flex: 1;

      .performance_title {
        font-size: 16px;
        color: #666;
        margin-bottom: 12px;
      }

      .performance_value {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        margin-bottom: 8px;
      }
    }
  }
}

.dashboard_map_box {
  display: flex;

  .dashboard_map_card {
    width: 60%;

    .map_card_item_body {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      gap: 15px;

      .map_card_item {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        height: 40px;
        background: #EFF6FE;
        box-shadow: 1px 2px 2px 0px #D3E0EC;
        border-radius: 8px;
        padding: 0 8px;

        .map_card_item_title {
          font-size: 15px;
          color: #666666;
          display: flex;
          align-items: center;
          flex-shrink: 0;

          img {
            width: 24px;
            height: 24px;
            margin-right: 5px;
          }
        }

        .map_card_item_value {
          font-size: 18px;
          color: #000000;
          font-weight: bold;
        }
      }
    }

    .map_card_title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .title_warp {
        font-size: 24px;
        color: #333333;
        margin-left: 10px;
      }
    }

    .map_card_input {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      gap: 12px;

      .map_card_select,
      .map_card_input_region {
        flex: 1;
      }
    }
  }
}

// 平板设备 (768px - 1024px)
@media screen and (max-width: 1024px) {
  .dashboard_warp {
    padding: 20px;

    .dashboard_statistics_picture {
      gap: 20px;
      margin-left: 0;

      &.isShowMap {
        flex-direction: column;
      }
    }

    .dashboard_statistics_picture_item {
      width: 100%;
      padding: 20px;

      .statistics_picture_item_title {
        .title_warp {
          font-size: 20px;
        }
      }

      .statistics_picture_item_left {
        width: 65%;
      }

      .statistics_picture_item_right {
        width: 35%;
        margin-left: 15px;

        .statistics_picture_item_right_title {
          font-size: 16px;
        }

        .statistics_picture_item_right_value {
          font-size: 32px;
          padding: 8px 0;
        }
      }
    }
  }
}

// 移动设备 (max-width: 768px)
@media screen and (max-width: 768px) {
  .dashboard_map_box {
    display: block;


    .dashboard_warp {
      padding: 15px;
      height: calc(100vh - 120px);

      .dashboard_statistics_picture {
        flex-direction: column;
        gap: 15px;
        margin-left: 0;
      }

      .dashboard_statistics_picture_item {
        flex-direction: column;
        width: 100%;
        padding: 15px;

        .statistics_picture_item_title {
          margin-bottom: 15px;

          .title_warp {
            font-size: 18px;
          }
        }

        .statistics_picture_item_left {
          width: 100%;
          margin-bottom: 20px;
        }

        .statistics_picture_item_right {
          width: 100%;
          margin-left: 0;
          display: flex;
          justify-content: space-between;
          gap: 15px;

          >div {
            flex: 1;
            min-width: 0; // 允许内容收缩
          }

          .statistics_picture_item_right_title {
            font-size: 14px;
          }

          .statistics_picture_item_right_value {
            font-size: 24px;
            padding: 10px 5px;
            margin-top: 10px;
          }
        }
      }
    }


    .map_card_item_body {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      gap: 15px;

      .map_card_item {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        height: 40px;
        background: #EFF6FE;
        box-shadow: 1px 2px 2px 0px #D3E0EC;
        border-radius: 8px;
        padding: 0 8px;

        .map_card_item_title {
          font-size: 15px;
          color: #666666;
          display: flex;
          align-items: center;
          flex-shrink: 0;

          img {
            width: 24px;
            height: 24px;
            margin-right: 5px;
          }
        }

        .map_card_item_value {
          font-size: 18px;
          color: #000000;
          font-weight: bold;
        }
      }
    }

    // 3D地图模块样式
    .dashboard_map_card {
      background: #ffffff;
      box-shadow: 0px 1px 6px 0px rgba(204, 204, 204, 0.3);
      border-radius: 10px;
      padding: 30px;
      margin-bottom: 20px;
      box-sizing: border-box;
      width: 100% !important;

      .map_card_input {
        display: block;

        .map_card_select,
        .map_card_input_region,
        .map_card_clear {
          width: 100%;
          margin-top: 12px;
        }
      }

      .map_card_title {
        margin-bottom: 0;

        .title_warp {
          font-size: 24px;
          color: #333333;
          margin-left: 10px;
        }
      }
    }
  }
}


// 平板设备 (768px - 1024px)
@media screen and (max-width: 1024px) {
  .dashboard_performance_card {
    padding: 20px;

    .performance_card_header {
      margin-bottom: 15px;
    }

    .performance_card_body {
      padding-top: 15px;

      .performance_item {
        .performance_title {
          font-size: 14px;
        }

        .performance_value {
          font-size: 20px;
        }
      }
    }
  }
}

// 移动设备 (max-width: 768px)
@media screen and (max-width: 768px) {
  .dashboard_performance_card {
    padding: 15px;
    margin-top: 15px;

    .performance_card_body {
      flex-direction: column;
      gap: 15px;

      .performance_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 15px;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .performance_title {
          margin-bottom: 0;
        }

        .performance_value {
          margin-bottom: 0;
        }
      }
    }
  }
}

// 小屏移动设备 (max-width: 480px)
@media screen and (max-width: 480px) {
  .dashboard_warp {
    padding: 10px;

    .dashboard_statistics_picture_item {
      padding: 12px;

      .statistics_picture_item_title {
        .title_warp {
          font-size: 16px;
        }
      }

      .statistics_picture_item_right {
        flex-direction: column;
        gap: 10px;

        .statistics_picture_item_right_value {
          font-size: 20px;
          padding: 8px 5px;
        }
      }
    }
  }

  .dashboard_performance_card {
    padding: 12px;

    .performance_card_header {
      .performance_level {
        .level_button {
          padding: 4px 12px;
          font-size: 12px;
        }

        .current_level {
          font-size: 12px;
        }
      }
    }

    .performance_card_body {
      .performance_item {
        .performance_title {
          font-size: 12px;
        }

        .performance_value {
          font-size: 16px;
        }
      }
    }
  }

  .performance_agent_title {
    width: 200px;
    background: #b0daee;
    border-radius: 5px;
    font-weight: bold;
    font-size: 24px;
    color: #fff;
    padding: 10px 0;
    margin-top: 20px;
    text-align: center; // 改为居中显示
    word-break: break-all; // 确保数字可以换行
    box-sizing: border-box; // 确保padding计算在宽度内
  }
}
</style>
